import { useMemo, useState } from "react";
import { useApi } from "@/context/ApiContext";
import { useOrders } from "@/hooks/useOrders";
import { closedSince } from "@/lib/order-trades";

const DAY = 86_400_000;

/**
 * Realized P&L and win rate of the trades closed on the user's exchanges in
 * the last `days` days, matched from the latest orders. The dashboard cards
 * and the top bar share it (and so one subscription).
 */
export function useRecentResults(days = 30) {
  const api = useApi([]);
  const orders = useOrders({ account_id: "", limit: 500 }, api.ready);
  const [now] = useState(() => Date.now());
  const loaded = orders.status === "live" || orders.status === "reconnecting";
  return useMemo(() => {
    const r = closedSince(orders.rows, now - days * DAY);
    return { ...r, winRate: r.closed ? r.wins / r.closed : null, loaded };
  }, [orders.rows, now, days, loaded]);
}
